import { CardMedia } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import React, { FC, memo, ReactElement, useContext, useMemo, useState } from 'react'
import { Presence } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext, ReactState } from '../../Common/Contexts'
import { UserPresence } from '../Types/Types'
import { UserBadge } from '../../Common/Components/UserBadge/UserBadge'

type Props = {
    user: UserPresence
}

/**
 * Presence User Card Component
 */
export const PresenceUserCard: FC<Props> = memo(({ user }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(Presence.NAME)

    const [isImageLoaded, setIsImageLoaded]: ReactState<boolean> = useState<boolean>(false)

    const userAvailability: string = useMemo(
        (): string => user.presence.availability.toLowerCase(),
        [user.presence.availability]
    )

    const handleOnLoad = (): void => {
        setIsImageLoaded(true)
    }

    return (
        <Card variant='outlined'>
            <div className='tp-presence-user-badge-container'>
                {isImageLoaded ? null : <UserBadge name={user.name} />}
                <CardMedia
                    style={{ display: isImageLoaded ? 'block' : 'none' }}
                    component='img'
                    alt={user.name}
                    aria-label={user.name}
                    image={`/CCS/API/v1/internal/device/idOnTelSys/${user.userID}/userPhoto`}
                    title={user.name}
                    onLoad={handleOnLoad}
                />
            </div>
            <div className='tp-presence-user'>
                <h3 className='tp-presence-user-title' title={user.name}>
                    {user.name}
                </h3>
                <p className='tp-presence-user-dep' title={user.departments?.join(', ')}>
                    {user.departments?.join(', ')}
                </p>
                <div
                    className={`tp-presence-user-availability tp-presence-user-availability-${userAvailability}`}
                    title={language.get(`Presence_Activity_${user.presence.activity}_Title`)}
                >
                    <div
                        className={`tp-presence-user-availability-dot tp-presence-user-availability-${userAvailability}-bg`}
                    />
                    <span className='tp-presence-user-availability-activity'>
                        {language.get(`Presence_Activity_${user.presence.activity}_Title`)}
                    </span>
                </div>
            </div>
        </Card>
    )
})
